<template>
   <v-container>
      <v-sheet>
         <v-tabs
            height="40"
            v-model="vendortab"
            :slider-color="$globalstore.tab_slidercolor"
            @change="onTabChange"
         >
            <v-tab href="#today">Today</v-tab>
            <v-tab href="#week">Week</v-tab>
         </v-tabs>
         <v-tabs-items v-model="vendortab">
            <v-tab-item :key="1" value="today">
               <v-row class="pt-3">
                  <v-col cols="12" md="8">
                     <table
                        :width="$vuetify.breakpoint.mobile ? '100%' : '75%'"
                     >
                        <tr>
                           <td width="10%">
                              <v-icon class="pr-2" @click="prevDay"
                                 >mdi-chevron-left
                              </v-icon>
                           </td>
                           <td
                              :width="
                                 $vuetify.breakpoint.mobile ? '40%' : '35%'
                              "
                           >
                              {{ currentdatedisplay }}
                           </td>
                           <td width="10%">
                              <v-icon class="pl-2" @click="nextDay"
                                 >mdi-chevron-right
                              </v-icon>
                           </td>
                           <td
                              :width="
                                 $vuetify.breakpoint.mobile ? '40%' : '45%'
                              "
                              align="right"
                           >
                              <v-btn outlined color="indigo" @click="goToday"
                                 >Today
                              </v-btn>
                           </td>
                        </tr>
                     </table>
                  </v-col>
               </v-row>
               <v-row>
                  <v-col cols="12" md="6">
                     <div class="100vh">
                        <v-card
                           height="70vh"
                           class="overflow-y-auto"
                           outlined
                           tile
                           v-for="grp in groupinfo"
                           :key="grp.cca_id"
                        >
                           <v-card-title
                              >{{ grp.cca_name }}
                              <v-card-subtitle v-if="grp.eventdata.length == 0">
                                 No events scheduled for today.
                              </v-card-subtitle>
                           </v-card-title>
                           <v-row
                              class="pl-5"
                              v-for="evt in grp.eventdata"
                              :key="evt.event_id"
                           >
                              <tr class="pl-2 my-1">
                                 <td width="100px" height="45px">
                                    {{ evt.event_date }}
                                 </td>
                                 <td width="100px">
                                    {{ evt.event_starttime }}
                                 </td>
                                 <td width="100px">{{ evt.event_endtime }}</td>
                              </tr>
                              <v-btn
                                 class="mb-5"
                                 color="primary"
                                 :disabled="checkTime(evt)"
                                 @click="
                                    doAttendance(
                                       grp.cca_id,
                                       evt.event_id,
                                       evt.event_date
                                    )
                                 "
                                 ><v-icon>mdi-account-outline</v-icon>
                                 <template v-if="$vuetify.breakpoint.mdAndUp"
                                    >Attendance</template
                                 >
                              </v-btn>
                           </v-row>
                        </v-card>
                     </div>
                  </v-col>
               </v-row>
            </v-tab-item>
            <v-tab-item :key="2" value="week">
               <v-col md="6">
                  <v-expansion-panels v-model="panelarray" multiple>
                     <v-expansion-panel
                        v-for="grp in scheduledata"
                        :key="grp.cca_id"
                     >
                        <v-expansion-panel-header>
                           {{ grp.cca_name }}<br />
                           {{ grp.cca_description }}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                           <v-data-table
                              dense
                              :items="grp.eventdata"
                              :headers="event_headers"
                              @click:row="tableRowClick"
                              item-key="event_id"
                              hide-default-footer
                              single-select
                           >
                           </v-data-table>
                        </v-expansion-panel-content>
                     </v-expansion-panel>
                  </v-expansion-panels>
               </v-col>
            </v-tab-item>
         </v-tabs-items>
      </v-sheet>
   </v-container>
</template>

<script>
   export default {
      inject: ["ShowMessage"],

      data() {
         return {
            vendortab: "",
            groupinfo: [],
            sysdatetime: null,
            scheduledata: [],
            panelarray: [],
            event_headers: [
               {
                  text: "Date",
                  value: "event_date",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Start",
                  value: "event_starttime",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "End",
                  value: "event_endtime",
                  class: this.$globalstore.table_headerclass,
               },
            ],
            currentdate: new Date(),
            todaydate: new Date(),
            currentyearterm: null, // id, term, year, termyeartext, term_start, term_end
         };
      },

      computed: {
         currentdatedisplay() {
            const daytext = Intl.DateTimeFormat("en-US", {
               weekday: "long",
            }).format(this.currentdate);
            return (
               // this.currentdate.toISOString().substr(0, 10) + "  " + daytext
               this.$globalstore
                  .dateToISOString(this.currentdate)
                  .substr(0, 10) + daytext
            );
         },
      },

      methods: {
         onTabChange(tab) {
            if (tab === "today") {
               this.loadVendorGroups();
            }
         },

         prevDay() {
            if (
               // this.currentdate.toISOString().substr(0, 10) >
               // this.todaydate.toISOString().substr(0, 10)
               this.$globalstore
                  .dateToISOString(this.currentdate)
                  .substr(0, 10) >
               this.$globalstore.dateToISOString(this.todaydate).substr(0, 10)
            ) {
               let prevday = new Date(this.currentdate);
               prevday.setDate(this.currentdate.getDate() - 1);
               this.currentdate = prevday;
               this.loadVendorGroups();
            }
         },

         nextDay() {
            if (
               // this.currentdate.toISOString().substr(0, 10) <
               // this.currentyearterm.term_end
               this.$globalstore
                  .dateToISOString(this.currentdate)
                  .substr(0, 10) < this.currentyearterm.term_end
            ) {
               let nextday = new Date(this.currentdate);
               nextday.setDate(this.currentdate.getDate() + 1);
               this.currentdate = nextday;
               this.loadVendorGroups();
            }
         },

         goToday() {
            this.currentdate = new Date();
            this.loadVendorGroups();
         },

         tableRowClick(item, row) {
            row.select(!row.isSelected);
            console.log(row);
         },

         async loadVendorGroups() {
            let response = await this.$http({
               url: "/cca/gettodaygroup_byadmid.php",
               headers: { "Content-Type": "application/x-www-form-urlencoded" },
               data: {
                  date: this.currentdatedisplay,
                  id: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.groupinfo = response.data.groupdata;
                  }
               }
            });
         },

         async loadVendorWeekSchedule() {
            let response = await this.$http({
               url: "/cca/getvendorweekschedule.php",
               headers: { "Content-Type": "application/x-www-form-urlencoded" },
               data: {
                  vendorid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.scheduledata = response.data.scheduledata;
                     this.panelarray = this.scheduledata.map((obj, i) => i);
                  }
               }
            });
         },

         checkTime(evt) {
            return !this.checkStartEnd(evt.event_starttime, evt.event_endtime);
         },

         addMinutes(time, minsToAdd) {
            function D(J) {
               return (J < 10 ? "0" : "") + J;
            }
            var piece = time.split(":");

            var mins = piece[0] * 60 + +piece[1] + +minsToAdd;

            return D(((mins % (24 * 60)) / 60) | 0) + ":" + D(mins % 60);
         },

         checkStartEnd(start, end) {
            if (
               !/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(start) ||
               !/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(end)
            ) {
               return false;
            }

            let gracetime = this.$globalstore.appsettings
               .attendance_grace_minute;
            let now = this.getCurrentTime();

            //console.log("now ", now);
            if (this.addMinutes(start, -gracetime) > now) {
               // current time is not within gracetime of start time
               // console.log(
               //    "current time is not within gracetime of start time"
               // );
               return false;
            } else if (this.addMinutes(end, +gracetime) < now) {
               // current time is more than end time including grace time
               // console.log(
               //    "current time is more than end time including grace time"
               // );
               //console.log("end = ", this.addMinutes(end, +gracetime));

               return false;
            } else {
               // current time must be within start and end including grace
               // console.log(
               //    "current time must be within start and end including grace"
               // );
               return true;
            }
         },

         getCurrentTime() {
            let now = new Date().toLocaleTimeString().substr(0, 5);
            return now;
         },

         async getCurrentYearTerm() {
            let response = await this.$http({
               url: "/common/currentyearterm.php",
               headers: { "Content-Type": "application/x-www-form-urlencoded" },
               data: {
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.currentyearterm = response.data.currentyearterm;
                  }
               }
            });
         },

         doAttendance(ccaid, eventid, eventdate) {
            console.log("ccaid ", ccaid);
            this.$router.push({
               name: "VendorAttendance",
               params: { eventid: eventid, ccaid: ccaid, eventdate: eventdate },
            });
         },
      },
      mounted() {
         this.getCurrentYearTerm();
         this.loadVendorGroups();
         this.loadVendorWeekSchedule();
      },
   };
</script>
